module.exports = __webpack_public_path__ + "img/ssb_menu13.fae033c7.png";